import * as React from 'react'
import { useEffect, useState } from 'react'

import { Field, useFormikContext } from 'formik'
import Stack from '@mui/material/Stack'

import { styles } from './styling'
import { useHandlers } from './hooks/useHandlers'
import { TidalTextFormikField } from '@sales-center/components'
import { UseSystemNameLabel } from './UseSystemNameLabel'
import { createSystemOpportunityName } from './functions'
import { MuiRadioGroupFormik } from '@user/components/Formik'
import { ILeadOppProduct } from '@user/store/leadOppProducts/typings'

interface Props {
  disabled?: boolean
  initialValue: string
  services: ILeadOppProduct[]
  showLabel?: boolean
  size?: string
}

const options = [
  {
    label: <UseSystemNameLabel />,
    value: 'true',
  },
  {
    label: 'Enter Custom Name',
    value: 'false',
  },
]

export function OpportunityName<T>(props: Props) {
  const { disabled, initialValue, services, showLabel = false } = props

  const [customName, setCustomName] = useState<string>()
  const { values, setFieldValue } = useFormikContext<T>()
  const opportunityName = values['opportunityName']
    ? values['opportunityName']
    : ''

  const useSystemName: boolean = values['useSystemName'] === 'true'
  useEffect(() => {
    if (!useSystemName) {
      setCustomName(opportunityName)

      if (opportunityName && opportunityName.trim().length > 0) {
        setFieldValue('opportunityName', opportunityName)
      }
    } else {
      setFieldValue('opportunityName', createSystemOpportunityName(services))
    }
  }, [
    setCustomName,
    useSystemName,
    opportunityName,
    initialValue,
    setFieldValue,
    services,
  ])
  const { onChange } = useHandlers<T>({ ...props, customName })

  return (
    <Stack gap={1.5}>
      <TidalTextFormikField
        required
        name="opportunityName"
        label="Opportunity Name"
        disabled={disabled || useSystemName}
        inputProps={{ maxLength: 100, 'data-test-id': 'opportunityName' }}
      />
      <Field
        name="useSystemName"
        component={MuiRadioGroupFormik}
        label={showLabel && 'Opportunity Name'}
        labelClassName={styles.label}
        onClick={onChange}
        options={options}
        disabled={false}
        radioProps={{ size: 'small' }}
        radioLabelProps={{ size: 'small' }}
        row
        data-test-id="use-system-name-radio-group"
      />
    </Stack>
  )
}

OpportunityName.displayName = 'OpportunityNameField'
